import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

export function AuthLayout({ children }: Props) {
    return (
        <div className="bg-muted/70 flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
            <div className="mb-8 flex w-full max-w-sm flex-col">
                <div className="-mt-4 flex items-center justify-center">
                    <div
                        className="bg-primary size-[8em] mask-[url(/img/logo.png)] mask-alpha mask-contain"
                        role="img"
                        aria-description="Symbol: the tape cassette icon combined with the papers inbox icon"
                    />
                </div>
                {children}
            </div>
        </div>
    );
}
